/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DeviceTVIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Device T V',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35 8H19.414l6.247-6.247a.971.971 0 0 0 0-1.411 1 1 0 0 0-1.416 0L18 6.586 11.776.362a.99.99 0 0 0-1.42-.006.971.971 0 0 0 .006 1.42L16.586 8H1a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h34a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Zm-5 22H4V12h26Zm4-1a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0Z"
    />
  </svg>`;
};
